// extracted by mini-css-extract-plugin
module.exports = {"counter-project":"GeneralStatistics_counter-project__2O6oj","loading":"GeneralStatistics_loading__fbRG2","counter-title":"GeneralStatistics_counter-title__3KHMb"};